module.exports = __webpack_public_path__ + "static/media/Group77.61186ef4.png";